<template>
  <div v-if="terminal.guid" class="contacts-terminals-card">
    <vz-close-btn v-if="closable" class="close-btn" @click="emit('close')" />
    <div class="contacts-terminals-card-body" itemscope itemtype="http://schema.org/LocalBusiness">

      <template v-if="!hasAddress">
        <div class="display-none" itemprop="telephone">
          {{ phone }}
        </div>
        <div class="display-none" itemprop="name">
          {{ itempropName }}
        </div>
        <h3 class="contacts-terminals-card-title">
          Контакты
        </h3>
        <div class="contacts-terminals-card-subtitle">
          Адрес
        </div>
        <div itemprop="address">{{ terminal.address }}</div>
        <div v-if="terminal.note" class="mt-5 mb-10">
          {{ terminal.note }}
        </div>
        <div class="contacts-terminals-card-links flex">
          <nuxt-link :to="schemeLink" target="_blank" class="contacts-terminals-card-link mr-20">
            Схема проезда
          </nuxt-link>
          <nuxt-link :to="link" class="contacts-terminals-card-link">
            {{ linkTitle }}
          </nuxt-link>
        </div>
      </template>
      <template v-else>
        <div class="contacts-terminals-card-subtitle contacts-terminals-card-subtitle--margin-none">
          Адрес
        </div>
        <div class="display-none" itemprop="name">
          {{ itempropName }}
        </div>
        <div class="display-none" itemprop="telephone">
          {{ phone }}
        </div>
        <div itemprop="address">{{ terminal.address }}</div>
        <div v-if="terminal.note" class="mt-5 mb-10">
          {{ terminal.note }}
        </div>
      </template>

      <contacts-terminals-schedule :terminal-guid="terminalGuid" />
    </div>
    <div
      v-if="!hasAddress"
      class="contacts-terminals-card-footer"
    >
      <div class="contacts-terminals-card-footer-wrapper flex flex-space-between">
        <vz-button
          big
          outline
          variant="primary"
          :to="getOrderCreateLink(true)"
        >
          Отправить отсюда
        </vz-button>
        <vz-button
          big
          variant="primary"
          :to="getOrderCreateLink(false)"
        >
          Отправить сюда
        </vz-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia'
import {Terminal} from '~/types/types'
import {useCityStore} from '~~/stores/city'
import {useTerminalStore} from '~/stores/terminal'
import ContactsTerminalsSchedule from '~/components/public/contacts/contacts-terminals-schedule.vue'
import VzButton from '~/components/ui-kit/vz-button.vue'

const {currentCity, currentPhones} = storeToRefs(useCityStore())
const {terminalList} = storeToRefs(useTerminalStore())

const emit = defineEmits(['close'])

const props = defineProps({
  closable: {
    type: Boolean,
    default: false
  },
  terminalGuid: {
    type: String,
    default: ''
  },
  hasAddress: {
    type: Boolean,
    default: false
  },
  withMapLink: {
    type: Boolean,
    default: false
  }
})

const terminal = computed((): Terminal => {
  return terminalList.value.find(t => t.guid === props.terminalGuid) || {} as Terminal
})

const schemeLink = computed(() => {
  return `/mapScheme?g=${terminal.value.guid}`
})

const link = computed(() => {
  return props.withMapLink
    ? { name: 'terminals', query: { terminalGuid: terminal.value.guid }, hash: '#city' }
    : `/contacts?terminal=${terminal.value.address}`
})

const linkTitle = computed(() => {
  return props.withMapLink ? 'Показать на карте' : 'Контакты'
})

const phone = computed(() => {
  const data = currentPhones.value?.[0] || '7 (812) 389-21-12'

  const ind = data.indexOf(')')
  return ind > 0 ? `<span>${data.substring(0, ind + 1)}</span>${data.substring(ind + 1)}` : data
})

const itempropName = computed(() => {
  return `Возовоз - ${terminal.value?.location?.name || ''}`
})

function getOrderCreateLink(isDispatch: boolean) {
  const {location_guid, guid} = terminal.value
  const query: any = {}

  if (isDispatch) {
    query.dispatch_point = 'terminal'
    query.location_dispatch = location_guid || ''
    query.dispatch_terminal = guid || ''
  } else {
    query.location_dispatch = currentCity.value.guid
    query.destination_point = 'terminal'
    query.location_destination = location_guid || ''
    query.destination_terminal = guid || ''
  }

  return {
    name: 'order-create',
    query
  }
}
</script>
